import { FormattedNumber } from 'react-intl';

import { LabelS } from 'atoms/typography';

type Props = {
  cumulatedScoreDifference: number;
};

export const CumulatedScoreDifference = ({
  cumulatedScoreDifference,
}: Props) => {
  return (
    <LabelS as="span" color="var(--c-nd-700)">
      <FormattedNumber
        value={cumulatedScoreDifference}
        signDisplay="exceptZero"
        maximumFractionDigits={0}
      />
    </LabelS>
  );
};
